module.exports = __webpack_public_path__ + "hm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/hm.svg
// module id = 594
// module chunks = 0